export const BOOT = "BOOT";
export const SHARED_LOAD = "SHARED_LOAD";
export const COLORING = "COLORING";
export const STORYCIRCLE = "STORYCIRCLE";
export const TITLE = "TITLE";
export const RECAP = "RECAP";
export const POSTGAME = "POSTGAME";
export const CONGRATULATIONS = "CONGRATS";
